import { render, staticRenderFns } from "./LevelTable.vue?vue&type=template&id=c2e9c416&scoped=true"
import script from "./LevelTable.vue?vue&type=script&lang=js"
export * from "./LevelTable.vue?vue&type=script&lang=js"
import style0 from "./LevelTable.vue?vue&type=style&index=0&id=c2e9c416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e9c416",
  null
  
)

export default component.exports